<template>
  <div class="profile__wrap">
    <div v-if="error" class="profile-success profile-success--error">
      <header-text :label="$t('connect_account')" :title="$t('error')" />

      <div v-if="platform === 'steam'" class="platform">
        <div class="platform__icon"><iconSteam color="white" /></div>
        <p class="platform__description">
          {{ error }}
        </p>
      </div>

      <div v-else-if="platform === 'galaxy'" class="platform">
        <div class="platform__icon"><iconGalaxy color="white" /></div>
        <p class="platform__description">
          {{ error }}
        </p>
      </div>

      <a href="#" class="btn --large" @click.prevent="completeOnboarding">
        <span class="btn__stroke"></span>
        <span class="btn__label">{{ $t("ok") }}</span>
      </a>
    </div>

    <div v-else class="profile-success">
      <header-text :label="$t('connect_account')" :title="$t('success')" />

      <div v-if="platform === 'steam'" class="platform">
        <div class="platform__icon"><iconSteam color="white" /></div>
        <p class="platform__description">
          {{ $t("steam_successfully_link") }}
        </p>
      </div>

      <div v-else-if="platform === 'galaxy'" class="platform">
        <div class="platform__icon"><iconGalaxy color="white" /></div>
        <p class="platform__description">
          {{ $t("galaxy_successfully_link") }}
        </p>
      </div>

      <a href="#" class="btn --large" @click.prevent="completeOnboarding">
        <span class="btn__stroke"></span>
        <span class="btn__label">{{ $t("ok") }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import iconSteam from "@/components/Icons/iconSteam.vue";
import iconGalaxy from "@/components/Icons/iconGalaxy.vue";

export default {
  components: {
    iconSteam,
    iconGalaxy
  },

  props: {
    error: {
      type: String
    },

    platform: {
      type: String,
      required: true
    }
  },

  methods: {
    completeOnboarding() {
      this.$emit("completeOnboarding");
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-success {
  display: flex;
  flex-direction: column;
  align-items: center;

  .btn {
    width: 200px;
  }

  .platform {
    width: 100%;
    border: 2px solid $green-darker;
    background: $green-darker-25;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 45px 60px 60px 60px;

    &__description {
      color: $white;
      text-align: center;
      margin: 25px 0 0 0;
    }
  }

  &--error {
    .platform {
      border-color: $red;
      background: $red-25;
    }
  }
}

@media screen and (max-height: 800px) {
  .profile-success {
    .platform {
      padding: 35px 50px 50px 50px;
    }
  }
}
</style>
